/**
 * Frontend logger utility for conditional logging.
 * Only logs in development mode (when import.meta.env.DEV is true).
 *
 * Usage:
 *   import { logger } from '../utils/logger';
 *   logger.log('Debug message');
 *   logger.warn('Warning message');
 *   logger.error('Error message'); // Always logs (production errors matter)
 */

const isDev = import.meta.env.DEV;

export const logger = {
  /**
   * Log debug information (dev only)
   */
  log: (...args: unknown[]): void => {
    if (isDev) {
      console.log(...args);
    }
  },

  /**
   * Log warnings (dev only)
   */
  warn: (...args: unknown[]): void => {
    if (isDev) {
      console.warn(...args);
    }
  },

  /**
   * Log errors (always - production errors are important)
   */
  error: (...args: unknown[]): void => {
    console.error(...args);
  },

  /**
   * Log info (dev only)
   */
  info: (...args: unknown[]): void => {
    if (isDev) {
      console.info(...args);
    }
  },

  /**
   * Log debug (dev only)
   */
  debug: (...args: unknown[]): void => {
    if (isDev) {
      console.debug(...args);
    }
  },
};

export default logger;
